var _defs, _rect, _path, _path2, _path3, _path4, _circle, _path5, _path6, _path7, _path8, _g, _path9, _path0, _path1, _g2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgScreenRecording = function SvgScreenRecording(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    viewBox: "0 0 640 480"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "screen-recording_svg__a",
    x1: 417.01,
    x2: 168.57,
    y1: 317.43,
    y2: 208.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b3b3b3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b3b3b3",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("filter", {
    id: "screen-recording_svg__b",
    width: 1.712,
    height: 1.421,
    x: -0.402,
    y: -0.223,
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodColor: "#000",
    floodOpacity: 0.498,
    result: "flood"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    "in": "SourceGraphic",
    result: "blur",
    stdDeviation: 1.5
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -1.057,
    dy: -0.453,
    "in": "blur",
    result: "offset"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "flood",
    in2: "offset",
    operator: "in",
    result: "comp1"
  }), /*#__PURE__*/React.createElement("feComposite", {
    "in": "SourceGraphic",
    in2: "comp1",
    result: "comp2"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 640,
    height: 480,
    fill: "#fff",
    opacity: 0.999,
    ry: 11.675
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#3b73c4",
    d: "M32.913 458.17h5.824v-20.383h-5.824M21.266 458.17h5.824v-20.383h-5.824z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#3b73c4",
    strokeWidth: 4.001,
    d: "M267.86 413.96h83.047M378.67 413.96h60.049M453.83 413.96h26.083M507.48 413.96h132.44M117.35 413.96h104.57"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#e3dbdb",
    strokeWidth: 4.001,
    d: "M221.91 413.96h45.995M351 413.96h27.568M438.63 413.96h15.184M479.88 413.96h27.568"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#ac9393",
    strokeWidth: 4,
    d: "M0 413.83h117.12"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 116.33,
    cy: 413.83,
    r: 10.424,
    fill: "#3b73c4",
    stroke: "#fff",
    strokeLinecap: "round",
    strokeWidth: 3,
    opacity: 0.999
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#e6e6e6",
    d: "M239.8 443.44h160.39v12.973H239.8z",
    opacity: 0.999
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#f2f2f2",
    d: "M47.091 49.535h225.85v215.82H47.091zM285 201.67h67.813v63.686H285zM285 125.6h67.813v63.686H285zM285 49.535h67.813v63.686H285z",
    opacity: 0.999
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ccc",
    d: "M387.3 49.535h191.65v16.511H387.3zM387.3 77.842h116.76v16.511H387.3zM387.3 136.32h191.65v10.614H387.3zM387.3 154.78h191.65v10.614H387.3zM387.3 173.24h191.65v10.614H387.3zM387.3 191.7h149.78v10.614H387.3z",
    opacity: 0.999
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#f93c67",
    d: "M387.3 232.93h105.55v32.432H387.3z",
    opacity: 0.999
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#f2f2f2",
    strokeWidth: 1.443,
    transform: "translate(68.787 118.28)scale(.69291)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 180.15,
    cy: 322.46,
    r: 37.445,
    opacity: 0.999
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 301.75,
    cy: 322.46,
    r: 37.445,
    opacity: 0.999
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 423.35,
    cy: 322.46,
    r: 37.445,
    opacity: 0.999
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 544.95,
    cy: 322.46,
    r: 37.445,
    opacity: 0.999
  }))), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M439.13 239.16v3.632h-1.816l3.632 3.631 3.631-3.632h-1.816v-3.631m-11.802 1.816v1.816h1.816l3.268 6.9-1.27 2.178c-.092.273-.182.545-.182.908 0 .999.817 1.816 1.816 1.816H447.3v-1.816H436.77a.195.195 0 0 1-.182-.181v-.091l.817-1.544h6.719c.635 0 1.27-.363 1.543-.908l3.54-6.355-1.543-.908-3.54 6.356h-6.356l-3.813-8.171m2.452 14.526c-.999 0-1.816.817-1.816 1.816s.817 1.815 1.816 1.815c.998 0 1.815-.817 1.815-1.815s-.817-1.816-1.815-1.816m9.078 0c-.998 0-1.815.817-1.815 1.816s.817 1.815 1.815 1.815 1.816-.817 1.816-1.815-.817-1.816-1.816-1.816"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "gray",
    d: "M195.45 224.47c-.759-.348-1.122-.8-1.375-1.71-.189-.681-.778-6.526-1.308-12.99s-1.05-11.888-1.153-12.054-.457-.302-.788-.302c-.502 0-1.222 1.868-4.394 11.407-2.086 6.273-4.058 11.935-4.382 12.58-1.007 2.008-1.87 2.04-7.769.294-8.077-2.391-17.175-5.957-23.417-9.177-4.101-2.116-6.32-3.877-6.32-5.015 0-1.456 12.04-36.744 15.84-46.427 1.485-3.787 2.91-5.959 4.373-6.664.84-.405 1.418-.334 5.972.738 15.601 3.674 36.128 6.34 48.841 6.343 4.611.001 5.964.33 6.788 1.65 1.156 1.85 4.26 26.354 5.913 46.673.87 10.708 1.22 9.81-4.59 11.774-6.537 2.21-12.123 2.973-23.433 3.199-6.372.127-7.952.07-8.798-.318zm-69.334-26.778c-1.83-1.257-2.145-2.195-3.056-9.083-.974-7.368-2.51-15.742-4.619-25.174-1.47-6.572-4.178-17.121-4.471-17.414-.236-.236-1.251 1.123-3.28 4.392-2.52 4.06-2.614 4.131-5.42 4.083-2.714-.047-6.798-1.308-10.95-3.382-5.804-2.899-7.054-3.953-7.054-5.95 0-1.022 10.413-28.526 11.876-31.37 1.485-2.885 6.033-6.952 12.612-11.275 8.271-5.437 10.878-7.04 11.447-7.04.318 0 1.355.663 2.304 1.474 3.496 2.988 7.82 4.463 13.051 4.452 7.44-.014 14.244-3.408 17.636-8.795.906-1.439 1.737-2.388 2.199-2.512.963-.257 3.523.468 10.098 2.862 10.082 3.669 12.74 5.22 18.39 10.73 5.27 5.141 18.514 20.016 19.379 21.767.91 1.843.397 2.999-2.587 5.812-2.706 2.552-9.27 8.12-11.123 9.436-.586.416-1.5.725-2.146.725-1.178 0-1.834-.453-6.084-4.2l-2.012-1.774.217 3.553c.12 1.955.377 5.199.573 7.21.196 2.01.283 3.729.193 3.819-.227.227-6.715-1.022-11.563-2.227-7.028-1.746-10.164-1.172-13.768 2.519-2.18 2.233-3.462 4.867-6.769 13.914-1.366 3.737-3.22 8.761-4.121 11.164s-2.995 8.373-4.655 13.268c-3.506 10.337-2.281 9.203-10.329 9.564-4.749.213-4.878.2-5.969-.549z"
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "url(#screen-recording_svg__a)",
    strokeLinecap: "round",
    strokeWidth: 4.5,
    d: "M230.57 91.99c100.97-79.973 288.37 33.874 86.864 129.03-120.18 56.753-51.5 166.04 55.544 157.42 62.972-5.072 125.61-37.837 109.98-92.449"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    strokeWidth: 0.136,
    filter: "url(#screen-recording_svg__b)",
    transform: "translate(452.81 242.23)scale(1.9421)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M19.8 16.5H13l-.4.1-4.4 4.3v-16z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "m12.7 10.5 4.6 11.1-3.6 1.5L9 12z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m11.03 14.293 1.845-.774 3.096 7.376-1.844.775z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m12.2 15.6.4-.1h4.8L9.2 7.3v11.2z"
  }))));
};
export default SvgScreenRecording;